import { render } from "./VideoCourseware.vue?vue&type=template&id=bbd87644&scoped=true"
import script from "./VideoCourseware.vue?vue&type=script&lang=js"
export * from "./VideoCourseware.vue?vue&type=script&lang=js"

import "./VideoCourseware.vue?vue&type=style&index=0&id=bbd87644&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bbd87644"

export default script